import { type ComponentPropsWithoutRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type StatusBarProps = ComponentPropsWithoutRef<'div'>;

export const StatusBar = memo(({ className, ...restOfProps }: StatusBarProps) => {
  return (
    <div
      className={cn(
        'absolute inset-x-0 bottom-0 z-30 flex h-10 w-full items-center justify-between bg-grey-4 px-4',
        className,
      )}
      {...restOfProps}
    />
  );
});

StatusBar.displayName = 'StatusBar';
